import React, { useEffect, useState } from 'react';
import '../styles/RedesSociales.css';

type MediaType = 'IMAGE' | 'VIDEO' | 'CAROUSEL_ALBUM';

interface InstagramPost {
  id: string;
  permalink: string;
  media_type: MediaType;
  media_url: string;
  thumbnail_url?: string;
  timestamp?: string;
  children?: {
    data: Array<{
      id: string;
      media_type: MediaType;
      media_url: string;
      thumbnail_url?: string;
    }>;
  };
}

const TOKEN =
  'IGAAWkGuRyzUtBZAFpFWXRGUGhwRDNmTnVKRlFQZA3hmZA2NQZAjFuTGJqWHV6aHdMSmtQRldTSjl3eTFCbzhUVmlxY000ZA1JvREpOV2d1bnlxcnFqRUd5MFlCaUI1d0V4WldXbjR6aGxyNDl5dVhBX1JQZA19mZAkVKRHNwZAERWSXhNWQZDZD';

const FIELDS =
  'id,media_type,media_url,permalink,thumbnail_url,timestamp,children{media_type,media_url,thumbnail_url}';

const RedesSociales: React.FC = () => {
  const [posts, setPosts] = useState<InstagramPost[]>([]);
  const [loading, setLoading] = useState(true);

  const getDisplaySrc = (p: InstagramPost): string | undefined => {
    if (p.media_type === 'IMAGE') return p.media_url;
    if (p.media_type === 'VIDEO') return p.thumbnail_url || undefined;
    if (p.media_type === 'CAROUSEL_ALBUM' && p.children?.data?.length) {
      const first = p.children.data.find(
        (c) => c.media_type === 'IMAGE' || !!c.thumbnail_url
      );
      if (!first) return undefined;
      return first.media_type === 'IMAGE'
        ? first.media_url
        : first.thumbnail_url;
    }
    return undefined;
  };

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        const res = await fetch(
          `https://graph.instagram.com/me/media?fields=${encodeURIComponent(
            FIELDS
          )}&limit=30&access_token=${TOKEN}`,
          { cache: 'no-store' }
        );
        const data = await res.json();

        if (!Array.isArray(data?.data)) return;

        const posts = data.data as InstagramPost[];
        const unique = Array.from(
          new Map(posts.map((p) => [p.id, p])).values()
        );

        // filtrar solo los que tengan algo que mostrar (imagen o thumbnail)
        const filtered = unique.filter((p) => !!getDisplaySrc(p) || p.media_type === 'VIDEO');

        // ordenar por fecha
        filtered.sort((a, b) => {
          const ta = new Date(a.timestamp ?? 0).getTime();
          const tb = new Date(b.timestamp ?? 0).getTime();
          return tb - ta;
        });

        if (isMounted) setPosts(filtered.slice(0, 10));
      } catch (err) {
        console.error('Error loading Instagram posts:', err);
        if (isMounted) setPosts([]);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchData();
    return () => {
      isMounted = false;
    };
  }, []);

  if (loading)
    return (
      <section className="redes-sociales-wrapper">
        <h2 className="titulo-redes">Redes Sociales</h2>
        <div>Cargando publicaciones…</div>
      </section>
    );

  return (
    <section className="redes-sociales-wrapper">
      <h2 className="titulo-redes">Redes Sociales</h2>
      <div className="instafeed-grid">
        {posts.map((post) => {
          const src = getDisplaySrc(post);
          const isVideo = post.media_type === 'VIDEO' && !src;

          return (
            <a
              key={post.id}
              href={post.permalink}
              target="_blank"
              rel="noopener noreferrer"
              className="insta-card"
              style={{ position: 'relative' }}
            >
              {src ? (
                <img
                  src={src}
                  alt="Instagram post"
                  loading="lazy"
                  decoding="async"
                  style={{ objectFit: 'cover' }}
                />
              ) : (
                <div
                  className="reel-placeholder"
                  style={{
                    background:
                      'linear-gradient(135deg, #222 0%, #555 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
                    fontSize: '1.2rem',
                    fontWeight: 500,
                    borderRadius: '12px',
                  }}
                >
                  🎥 Ver Reel en Instagram
                </div>
              )}
              {isVideo && (
                <div
                  style={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    background: 'rgba(0,0,0,0.6)',
                    borderRadius: '50%',
                    padding: '4px',
                  }}
                >
                  ▶
                </div>
              )}
            </a>
          );
        })}
      </div>
    </section>
  );
};

export default RedesSociales;
